import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { motion, useMotionValueEvent, useScroll } from 'framer-motion';
import { EASE } from './motion/primitives';
import ScrambleText from './motion/ScrambleText';

const links = [['#work', 'Work'], ['#contact', 'Contact'], ['/resume.pdf', 'Resume']];

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, 'change', (y) => {
    const prev = scrollY.getPrevious() ?? 0;
    setHidden(y > prev && y > 160);
    setScrolled(y > 24);
  });

  return (
    <motion.nav
      initial={{ y: '-110%' }}
      animate={{ y: hidden ? '-110%' : '0%' }}
      transition={{ duration: 0.45, ease: EASE }}
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0,
        zIndex: 100,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: scrolled ? '14px clamp(16px, 4vw, 56px)' : '24px clamp(16px, 4vw, 56px)',
        background: scrolled ? 'rgba(255,255,255,0.85)' : 'transparent',
        borderBottom: scrolled ? '1px solid rgba(14,14,12,0.1)' : '1px solid transparent',
        backdropFilter: scrolled ? 'blur(14px)' : 'none',
        WebkitBackdropFilter: scrolled ? 'blur(14px)' : 'none',
        transition: 'padding 0.35s cubic-bezier(0.22,1,0.36,1), background 0.35s, border-color 0.35s',
      }}
    >
      <motion.div whileHover="hover" initial="rest" animate="rest">
        <Link to="/" style={{
          fontFamily: 'var(--sans)',
          fontSize: '15px',
          fontWeight: 800,
          textDecoration: 'none',
          color: 'var(--ink)',
          letterSpacing: '-0.02em',
          whiteSpace: 'nowrap',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '9px',
        }}>
          <motion.span
            variants={{ rest: { rotate: 0 }, hover: { rotate: 135 } }}
            transition={{ type: 'spring', stiffness: 260, damping: 14 }}
            style={{
              width: 10, height: 10,
              background: 'var(--accent)', display: 'inline-block',
            }}
          />
          Muneeb Khan
        </Link>
      </motion.div>

      {isHome ? (
        <ul style={{ display: 'flex', gap: 'clamp(12px, 3vw, 36px)', listStyle: 'none', alignItems: 'center', margin: 0, padding: 0 }}>
          {links.map(([href, label]) => (
            <li key={href}>
              <a
                href={href}
                {...(href.endsWith('.pdf') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                style={{
                  fontFamily: 'var(--mono)',
                  fontSize: '12px',
                  fontWeight: 500,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: 'var(--ink-mid)',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'baseline',
                  gap: '5px',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.color = 'var(--accent)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'var(--ink-mid)'; }}
              >
                <ScrambleText text={label} trigger="hover" />
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <motion.div
          initial={{ opacity: 0, x: 12 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, ease: EASE }}
        >
          <motion.div whileHover="hover" initial="rest" animate="rest">
            <Link to="/" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontFamily: 'var(--mono)',
              fontSize: '12px',
              fontWeight: 500,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'var(--ink-mid)',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--accent)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--ink-mid)'; }}
            >
              <motion.svg
                width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"
                variants={{ rest: { x: 0 }, hover: { x: -4 } }}
                transition={{ type: 'spring', stiffness: 400, damping: 20 }}
              >
                <path d="M19 12H5M5 12l7-7M5 12l7 7" />
              </motion.svg>
              <ScrambleText text="All Work" trigger="hover" />
            </Link>
          </motion.div>
        </motion.div>
      )}
    </motion.nav>
  );
}
